var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelWebFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  x: 3,
  y: 3,
  fill: "#84C963",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M16.138 6.857a1 1 0 0 1 1.005 1.005v8.276a1 1 0 0 1-1.005 1.005H7.862a1 1 0 0 1-1.005-1.005V7.862a1 1 0 0 1 1.005-1.005zm-4.78 6.429H8.785v1.928h2.571zm3.856 0h-2.571v1.928h2.571zm-4.5-2.572H8.143v.643h2.571zm5.143 0H12v.643h3.857zm0-2.571H8.143v1.286h7.714z"
}))));
export default SvgGemChannelWebFilled;